import { isArray } from "lodash";
import { useContext } from "react";
import { Accordion, Table } from "react-bootstrap";
import dateTimeToJalali from "../../../../../function/jalali/dateTimetoJalali";
import FactorContext from "../context/FactorContext";
import style from "./PartsDetails.module.css";
import generateRandomString from "../../../../shop/components/Shipments/functions/generateRandomString";

function PartsDetails() {
  const { factorDetail } = useContext(FactorContext);

  const partition = (number, count) => {
    const value = isArray(number)
      ? number.reduce((sum, b) => sum + b, 0)
      : number;
    return Math.round(value / count);
  };

  const division = (number, count, noDivision = 0) => {
    const result = partition(number, count);
    return isNaN(result) && isNaN(noDivision)
      ? 0
      : (result + noDivision).toLocaleString();
  };

  return (
    <section>
      <Accordion alwaysOpen={true}>
        {factorDetail.shipments.map(({ item, partsdetail }, idx) => {
          return (
            <div key={idx}>
              {partsdetail.map((part, inx) => {
                const key = generateRandomString();
                return (
                  <Accordion.Item key={key} eventKey={key}>
                    <Accordion.Header className={style.header}>
                      <p className="m-0" style={{ fontSize: "1rem" }}>
                        <span>مشاهده فاکتور سفارش: </span>
                        <span className="fs-4 fw-semibold color-avaex-second">
                          {item.numberParcel}
                        </span>

                        {partsdetail.length > 1 && (
                          <span> (فقره {inx + 1})</span>
                        )}
                      </p>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Table striped hover className={"mb-5 " + style.table}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>شرح</th>
                            <th>تعداد</th>
                            <th>
                              <span>قیمت </span>
                              <small className="fw-light">(ریال)</small>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>هزینه پستی</td>
                            <td>1</td>
                            <td>{division(item.Freight, item.totalNumber)}</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>خدمات فنی</td>
                            <td>1</td>
                            <td>
                              {division(
                                [
                                  item.ServicesAt,
                                  item.cod_services,
                                  item.districtManagerShare,
                                  item.supervisorShare,
                                ],
                                item.totalNumber
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>جمع آوری کالا</td>
                            <td>1</td>
                            <td>
                              {division(item.collector, item.totalNumber)}
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>بیمه</td>
                            <td>1</td>
                            <td>
                              {division(item.Insurance, item.totalNumber)}
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>پیامک</td>
                            <td>1</td>
                            <td>
                              {division(item.hasNotifRequest, item.totalNumber)}
                            </td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>هزینه بسته بندی</td>
                            <td>1</td>
                            <td>
                              {division(item.Packaging, item.totalNumber)}
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>خدمات در محل</td>
                            <td>1</td>
                            <td>
                              {division(item.serviceInPlace, item.totalNumber)}
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>پرینت</td>
                            <td>1</td>
                            <td>
                              {division(item.printFactor, item.totalNumber)}
                            </td>
                          </tr>

                          <tr>
                            <td>9</td>
                            <td>مالیات بر ارزش افزوده</td>
                            <td>1</td>
                            <td>{division(item.TAX, item.totalNumber)}</td>
                          </tr>

                          {item.isCod === 1 && (
                            <tr>
                              <td>10</td>
                              <td>مبلغ Cod</td>
                              <td>1</td>
                              <td>
                                {isNaN(part.amountCOD)
                                  ? 0
                                  : part.amountCOD?.toLocaleString()}
                              </td>
                            </tr>
                          )}
                          {item.internal_section_id === 4 && (
                            <tr>
                              <td>{item.isCod === 1 ? 11 : 10}</td>
                              <td>تعرفه تعداد</td>
                              <td>1</td>
                              <td>{item.countPrice.toLocaleString()}</td>
                            </tr>
                          )}
                          <tr>
                            <td colSpan={2}></td>
                            <td className="text-center">جمع</td>
                            <td className="fw-semibold">
                              {division(
                                item.realPayable,
                                item.totalNumber,
                                part.amountCOD
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>

                      <p className="m-0">
                        <span>تاریخ: </span>
                        <span>{dateTimeToJalali(item.created_at).date}</span>
                        <span> - </span>
                        <span>{dateTimeToJalali(item.created_at).time}</span>
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </div>
          );
        })}
      </Accordion>
    </section>
  );
}

export default PartsDetails;
